import React from 'react'
import '../estilos/Nosotros.css'
import foto from '../img/ejemplo.jpg'
import foto1 from '../img/ejemplo1.jpg'
import foto2 from '../img/ejemplo2.jpg'
import foto3 from '../img/ejemplo3.jpg'

function Nosotros () {
  return (
    <div className='info'>
      <div className='infotexto'>
        <p > Uniclima (antes ClimAS del Norte) tiene una historia de más de 50 años ofreciendo soluciones en el confort ambiental en la Región Lagunera.</p>
        &nbsp;
        <p > Primero con equipos evaporativos y luego con equipos de aire acondicionado y calefacción, hemos atendido a clientes institucionales, comerciales y particulares.</p>
        &nbsp;
        <p > Hoy en día dedicamos parte de nuestro esfuerzo a soluciones de ahorro de energía y a ofrecer sistemas de energías alternativas como solar térmica y fotovoltaica.</p>
        &nbsp;
        <p > Hemos participado en varias obras importantes para distintos clientes.</p>
        &nbsp;
        <h1> Oficinas y Taller de Servicio </h1>
      </div>
      <div className='imagenes'>
        <p className='imagenes-'>
          <img src={foto} className='imagen__img' alt='Vista Local'></img>
          <img src={foto1} className='imagen__img' alt='Equipos'></img>
          <img src={foto2} className='imagen__img' alt='Equipos Parte 2'></img>
          <img src={foto3} className='imagen__img' alt='Equipos Parte 3'></img>
        </p>
      </div>
    </div>
  )
}

export default Nosotros
